import { render, staticRenderFns } from "./service-catalog-picker.vue?vue&type=template&id=4213870c&"
import script from "./service-catalog-picker.vue?vue&type=script&lang=js&"
export * from "./service-catalog-picker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports